export default function About() {
  return (
    <main className="pt-12 px-4 md:px-12" id="aboutMe">
      {/* Heading */}
      <h2 className="text-3xl font-bold text-center mb-6 dark:text-white text-black">
        ✨ About Me
      </h2>

      {/* Intro Paragraph */}
      <div className=" mx-auto text-center md:text-left">
        <p className="text-md leading-relaxed text-gray-800 dark:text-gray-300">
          I’m a full stack developer who loves building software that actually
          works and makes sense to real users — because honestly, I’ve rage-quit
          more than my fair share of clunky apps. I create smooth, intuitive
          interfaces with React and React Native, and keep the backend solid
          with Node.js, GraphQL, and AWS. On top of that, I work with Terraform,
          MySQL, and a little AI magic for good measure.
          <br />
          <br />
          But it’s not just about code, it’s about building lasting solutions,
          working with awesome people, and always learning. Whether it’s chasing
          down a tricky bug or convincing myself to train for a half marathon. I
          believe the best work happens when you stay curious, consistent, and
          having some fun along the way.
        </p>
      </div>

      {/* Sub Sections */}
      <section className="py-16 px-2">
        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {/* What I’m Doing Now */}
          {/* <div className="bg-white dark:bg-neutral-900 shadow-md rounded-xl p-6"> */}
          <div className="cursor-pointer p-6 rounded-2xl border border-primary/30 dark:border-primary/50 shadow-md hover:shadow-lg bg-white/80 dark:bg-neutral-900/80 backdrop-blur-sm transition-all">
            <h3 className="text-xl font-semibold mb-4 dark:text-white text-black">
              🧭 What I’m Doing Now
            </h3>
            <ul className="list-disc list-inside text-gray-800 dark:text-gray-300 space-y-2">
              <li>
                Building full stack projects with React, Node.js, GraphQL & AWS
              </li>
              <li>
                Sharpening my backend skills and diving deeper into system
                design
              </li>
              <li>
                Exploring AI and how to bring smart features into real-world
                apps
              </li>
              <li>
                Training for a half marathon and staying consistent with my
                fitness
              </li>
              <li>
                Staying curious, learning in public, and building things that
                matter
              </li>
            </ul>
          </div>

          {/* Recent Highlights */}
          {/* <div className="bg-white dark:bg-neutral-900 shadow-md rounded-xl p-6"> */}
          <div className="cursor-pointer p-6 rounded-2xl border border-primary/30 dark:border-primary/50 shadow-md hover:shadow-lg bg-white/80 dark:bg-neutral-900/80 backdrop-blur-sm transition-all">
            <h3 className="text-xl font-semibold mb-4 dark:text-white text-black">
              🚀 Recent Highlights
            </h3>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
              <li>Reduced CMS load time by 40%</li>
              <li>Built a secure app using AWS Cognito</li>
              <li>Mentored a junior developer</li>
              <li>Got AWS AI certified</li>
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
}
